/**
 * Mailer Template - shared type constants
 * Source of truth for template type options and chip colour mapping.
 *
 * Mirrors the 6 types currently in prod automation DB:
 * service=18, marketing=14, campaign=13, simple=5, system=2, event=1
 * Field is free-text on BE; constrained here to prevent typos.
 */

export const TEMPLATE_TYPE_OPTIONS = [
    { value: 'service', label: 'Service / Dịch vụ (invoice, thông báo KH)' },
    { value: 'marketing', label: 'Marketing / Lead alert nội bộ' },
    {
        value: 'campaign',
        label: 'Campaign / Broadcast KH (holiday, announcement)',
    },
    { value: 'simple', label: 'Simple / Mẫu đơn giản' },
    { value: 'system', label: 'System / Thông báo hệ thống' },
    { value: 'event', label: 'Event / Workflow (HR, hợp đồng)' },
]

export const MAILER_TEMPLATE_TYPE_CHIP_COLOR_MAP = {
    service: { label: 'service', color: 'info' as const },
    marketing: { label: 'marketing', color: 'warning' as const },
    campaign: { label: 'campaign', color: 'success' as const },
    simple: { label: 'simple', color: 'default' as const },
    system: { label: 'system', color: 'secondary' as const },
    event: { label: 'event', color: 'info' as const },
}
